import { useEffect, useState } from "react";
import { MessageCircle, Phone } from "lucide-react";
import { buildWhatsAppLink, PHONE_NUMBER_TEL } from "../lib/contact";

export const MobileStickyCTA = () => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        const onScroll = () => setShow(window.scrollY > 600);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <div
            data-testid="mobile-sticky-cta"
            className={`md:hidden fixed bottom-0 left-0 right-0 z-40 grid grid-cols-2 gap-px bg-white/10 border-t border-white/15 transition-all duration-300 ${
                show ? "translate-y-0" : "translate-y-full"
            }`}
        >
            <a
                href={buildWhatsAppLink()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="mobile-sticky-whatsapp"
                className="bg-[#FFC107] text-black font-body font-bold text-xs uppercase tracking-[0.2em] py-4 flex items-center justify-center gap-2"
            >
                <MessageCircle size={16} strokeWidth={2.5} />
                WhatsApp
            </a>
            <a
                href={`tel:${PHONE_NUMBER_TEL}`}
                data-testid="mobile-sticky-call"
                className="bg-black text-white font-body font-bold text-xs uppercase tracking-[0.2em] py-4 flex items-center justify-center gap-2"
            >
                <Phone size={16} strokeWidth={2.5} />
                Call Now
            </a>
        </div>
    );
};
